import { MoreOutlined } from '@ant-design/icons';
import { DarwinDropdown, DarwinFlex, DMenuProps } from 'components/darwin-ui';
import Icon, { IconName } from 'components/darwin-ui/Icon';
import styles from './ProcessMap.module.css';
import { useFloatNotification } from 'contexts/FloatNotificationContext';
import { useTranslation } from 'react-i18next';

type ThreeDotsAction = {
  key: string;
  name: IconName;
  label: string;
  onClick: () => void;
};

type CustomNodeThreeDotsActionProps = {
  onEdit?: () => void;
  onTest?: () => void;
  onDeploy?: () => void;
  onDeactivate?: () => void;
  onDelete: () => void;
  onView?: () => void;
  isSaved?: boolean;
};

export const CustomNodeThreeDotsAction = ({
  onEdit,
  onTest,
  onDeploy,
  onDeactivate,
  onDelete,
  onView,
  isSaved,
}: CustomNodeThreeDotsActionProps) => {
  const { openNotification } = useFloatNotification();
  const { t } = useTranslation();

  const safeAction = (action?: () => void) => {
    return () => {
      if (!isSaved) {
        openNotification(
          t('warning'),
          t('process-map.save-error'),
          'warning',
          'alert'
        );
        return;
      }
      action?.();
    };
  };

  const menuItems: ThreeDotsAction[] = [
    {
      key: '0',
      label: t('list-view.action-items.edit'),
      name: 'edit',
      onClick: safeAction(onEdit),
    },
    {
      key: '4',
      label: t('list-view.action-items.view'),
      name: 'view',
      onClick: safeAction(onView),
    },
    {
      key: '3',
      label: t('list-view.action-items.delete'),
      name: 'delete',
      onClick: () => onDelete(),
    },
    {
      key: '5',
      label: t('list-view.action-items.inactive'),
      name: 'inactivate',
      onClick: safeAction(onDeactivate),
    },
    {
      key: '1',
      label: t('list-view.action-items.test'),
      name: 'test',
      onClick: safeAction(onTest),
    },
    {
      key: '2',
      label: t('list-view.action-items.deploy'),
      name: 'deploy',
      onClick: safeAction(onDeploy),
    },
  ];

  const renderMenuItems = (): DMenuProps['items'] =>
    menuItems.map(item => ({
      key: item.key,
      label: (
        <DarwinFlex gap={8} align="center" onClick={item.onClick}>
          <Icon name={item.name} size="sm" color="inherit" />
          {item.label}
        </DarwinFlex>
      ),
    }));

  return (
    <DarwinDropdown
      menu={{ items: renderMenuItems() }}
      trigger={['click']}
      placement="bottom"
    >
      <MoreOutlined className={styles.customNodeThreeDotsIcon} />
    </DarwinDropdown>
  );
};
